(function () {
'use strict';

function __extends(d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// http://httpstat.us/418
var BLACKHOLE_STATUS = 418;
var ENABLE_BLOCK = process.env.PAPRIKA_ENV === 'production';
var DEV = process.env.NODE_ENV !== 'production';
var WHITELIST = [
    /catfront\.(51ping|dianping)\.com/i,
    /report\.meituan\.com/i,
    /frep\.meituan\.com/i,
];
// @ts-ignore
var wl = self._PAPRIKA_WHITELIST;
if (Array.isArray(wl)) {
    wl.forEach(function (w) {
        if (w instanceof RegExp) {
            WHITELIST.push(w);
        }
    });
}
// @ts-ignore
var PROJECT = String(self._PAPRIKA_PROJECT);
// @ts-ignore
var THRESHOLD = self._PAPRIKA_THRESHOLD;
if (typeof THRESHOLD !== 'number')
    THRESHOLD = 3;

var log;
if (DEV && self.console && console.log) {
    log = function (message) {
        console.log(message);
    };
}
else {
    log = function () { };
}
var log$1 = log;

var State = /** @class */ (function () {
    function State() {
        this._state = 'count';
        this.thresholdBlock = THRESHOLD;
        this.thresholdRecovery = 30;
        this.processing = 0;
        this.waiting = 0;
    }
    State.prototype.go = function (action) {
        this._updateCount(action);
        this._updateState();
        log$1("state=" + this._state + " | processing=" + this.processing + " | waiting=" + this.waiting);
    };
    State.prototype._updateCount = function (action) {
        switch (action) {
            case 'add':
                if (this._state !== 'recovery') {
                    this.processing++;
                }
                break;
            case 'substract':
                if (this.processing > 0) {
                    this.processing--;
                    this.waiting++;
                }
                break;
            case 'clear':
                if (this.waiting > 0) {
                    this.waiting--;
                }
                break;
        }
    };
    State.prototype._updateState = function () {
        var sum = this.processing + this.waiting;
        if (sum <= this.thresholdBlock) {
            this._state = 'count';
        }
        else if (sum <= this.thresholdRecovery) {
            this._state = 'block';
        }
        else {
            this._state = 'recovery';
        }
    };
    State.prototype.shouldBlock = function () {
        switch (this._state) {
            case 'count':
                return false;
            case 'block':
                return true;
            case 'recovery':
                return true;
        }
    };
    State.prototype.shouldDestroy = function () {
        var sum = this.processing + this.waiting;
        return sum === 0;
    };
    State.prototype.shouldIgnore = function () {
        return false;
    };
    return State;
}());
var EmptyState = /** @class */ (function (_super) {
    __extends(EmptyState, _super);
    function EmptyState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyState.prototype.go = function (action) { };
    EmptyState.prototype.shouldBlock = function () {
        return false;
    };
    EmptyState.prototype.shouldIgnore = function () {
        return true;
    };
    EmptyState.prototype.shouldDestroy = function () {
        return false;
    };
    return EmptyState;
}(State));
var EMPTY_STATE = new EmptyState();
var BlackholeState = /** @class */ (function (_super) {
    __extends(BlackholeState, _super);
    function BlackholeState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlackholeState.prototype.go = function (action) { };
    BlackholeState.prototype.shouldBlock = function () {
        return true;
    };
    BlackholeState.prototype.shouldIgnore = function () {
        return false;
    };
    BlackholeState.prototype.shouldDestroy = function () {
        return false;
    };
    return BlackholeState;
}(State));
var BLACKHOLE_STATE = new BlackholeState();
var StateManager = /** @class */ (function () {
    function StateManager() {
        var _this = this;
        this._stateMap = {};
        setInterval(function () { return _this._clear(); }, 1000);
    }
    StateManager.prototype.get = function (key) {
        if (!this._stateMap[key]) {
            if (WHITELIST.some(function (t) { return t.test(key); })) {
                this._stateMap[key] = EMPTY_STATE;
            }
            else {
                this._stateMap[key] = new State();
            }
        }
        return this._stateMap[key];
    };
    StateManager.prototype.block = function (key) {
        this._stateMap[key] = BLACKHOLE_STATE;
    };
    StateManager.prototype._clear = function () {
        var _this = this;
        Object.keys(this._stateMap).forEach(function (key) {
            var s = _this._stateMap[key];
            s.go('clear');
            if (s.shouldDestroy()) {
                delete _this._stateMap[key];
            }
        });
    };
    return StateManager;
}());
var StateMgr = new StateManager();

function parse(url) {
    var p = document.createElement('a');
    p.href = url;
    return {
        href: p.href,
        protocol: p.protocol,
        host: p.host,
        hostname: p.hostname,
        port: p.port,
        pathname: p.pathname,
        hash: p.hash,
        search: p.search,
    };
}

// const
var CAT_PROJECT = 'com.sankuai.hfe.isp.paprika';
var CAT_HOST = 'https://catfront.dianping.com';
if (DEV)
    CAT_HOST = 'https://catfront.51ping.com';
var CAT_ERROR_DETAIL = CAT_HOST + "/api/log?v=1";
var CAT_COUNT = CAT_HOST + "/api/metric?v=1&p=" + CAT_PROJECT;
var data = {
    err: [],
    count: {},
};
// private api
var send = function (url, data) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);
};
var report = function () {
    if (data.err.length) {
        var errData = 'c=' + encodeURIComponent(JSON.stringify(data.err));
        send(CAT_ERROR_DETAIL, errData);
        data.err = [];
    }
    Object.keys(data.count).forEach(function (page) {
        var cnt = data.count[page];
        if (cnt.length) {
            var countObj = {
                kvs: {
                    block: cnt,
                },
                tags: {
                    page: page,
                },
                ts: new Date().getTime(),
            };
            var countData = 'data=' + encodeURIComponent(JSON.stringify(countObj));
            send(CAT_COUNT, countData);
        }
    });
    data.count = {};
    data.count[PROJECT] = [];
};
var initial = function () {
    // fix ie bug
    // I don't know what happened
    var isIE = navigator.userAgent.match(/MSIE/i);
    if (!isIE && self.localStorage) {
        var LS_KEY_1 = '_PAPRIKA_LOG';
        try {
            var dataLS = localStorage.getItem(LS_KEY_1);
            localStorage.removeItem(LS_KEY_1);
            if (typeof dataLS === 'string') {
                var dataObj = JSON.parse(dataLS);
                data.err = dataObj.err;
                data.count = dataObj.count;
            }
        }
        catch (err) {
            log$1(err);
        }
        self.addEventListener('unload', function () {
            try {
                var dataLS = JSON.stringify(data);
                localStorage.setItem(LS_KEY_1, dataLS);
            }
            catch (err) {
                log$1(err);
            }
        });
    }
    report();
    var TIME = 60 * 1000;
    setInterval(report, TIME);
};
initial();
// public api
var allow = function (key) {
    log$1("[paprika] allowed | " + key);
    data.count[PROJECT].push(0);
};
var block = function (key, url) {
    log$1("[paprika] blocked | " + key);
    data.count[PROJECT].push(100);
    data.err.push({
        project: CAT_PROJECT,
        pageUrl: PROJECT,
        realUrl: location.href,
        resourceUrl: url,
        category: 'ajaxError',
        sec_category: key,
        level: 'warning',
        timestamp: new Date().getTime(),
    });
};
var report$1 = { allow: allow, block: block };

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
// polyfill for ie9
// @ts-ignore
function IECustomEvent(event, params) {
    params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined,
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}
// @ts-ignore
IECustomEvent.prototype = window.Event.prototype;
// @ts-ignore
if (typeof window.CustomEvent !== 'function') {
    // @ts-ignore
    window.CustomEvent = IECustomEvent;
}

var evt = new CustomEvent('error');
// @ts-ignore
evt._PAPRIKA_BLOCK = true;

// https://xhr.spec.whatwg.org/
var patch = function () {
    // @ts-ignore
    if (!self.XMLHttpRequest)
        return;
    // @ts-ignore
    var proto = self.XMLHttpRequest.prototype;
    var _open = proto.open;
    proto.open = function (method, url, async, user, password) {
        // init key
        var u = parse(url);
        var m = method.toUpperCase();
        this._paprika_key = m + "|" + u.protocol + "//" + u.host + u.pathname;
        this._paprika_url = url;
        _open.call(this, method, url, async, user, password);
    };
    var _send = proto.send;
    proto.send = function (body) {
        var _this = this;
        // update state
        var key = this._paprika_key;
        var state = StateMgr.get(key);
        if (state.shouldIgnore()) {
            this.addEventListener('load', function () {
                if (_this.status === BLACKHOLE_STATUS) {
                    StateMgr.block(key);
                }
            });
            _send.call(this, body);
        }
        else {
            // allow/block request
            state.go('add');
            if (!state.shouldBlock()) {
                report$1.allow(key);
                var endHandler_1 = function () { return state.go('substract'); };
                this.addEventListener('abort', endHandler_1);
                this.addEventListener('timeout', endHandler_1);
                this.addEventListener('error', endHandler_1);
                this.addEventListener('load', function () {
                    if (_this.status === BLACKHOLE_STATUS) {
                        StateMgr.block(key);
                    }
                    else {
                        endHandler_1();
                    }
                });
                _send.call(this, body);
            }
            else {
                report$1.block(key, this._paprika_url);
                state.go('substract');
                if (ENABLE_BLOCK) {
                    this.dispatchEvent(evt);
                }
                else {
                    _send.call(this, body);
                }
            }
        }
    };
};
patch();

// https://fetch.spec.whatwg.org/
var patch$1 = function () {
    if (!self.fetch)
        return;
    var _fetch = self.fetch;
    var patchedFetch = function (input, init) {
        // init key
        var u;
        var url;
        var method;
        if (typeof input === 'string') {
            method = 'GET';
            url = input;
            u = parse(input);
        }
        else {
            url = input.url;
            u = parse(input.url);
            method = input.method.toUpperCase();
        }
        if (init && init.method) {
            method = init.method.toUpperCase();
        }
        var key = method + "|" + u.protocol + "//" + u.host + u.pathname;
        // update state
        var state = StateMgr.get(key);
        if (state.shouldIgnore()) {
            var p = _fetch(input, init);
            p.then(function (resp) {
                if (resp.status === BLACKHOLE_STATUS) {
                    StateMgr.block(key);
                }
            });
            return p;
        }
        else {
            // allow/block request
            state.go('add');
            if (!state.shouldBlock()) {
                report$1.allow(key);
                var p = _fetch(input, init);
                p.catch(function () { return state.go('substract'); });
                p.then(function (resp) {
                    if (resp.status === BLACKHOLE_STATUS) {
                        StateMgr.block(key);
                    }
                    else {
                        state.go('substract');
                    }
                });
                return p;
            }
            else {
                report$1.block(key, url);
                state.go('substract');
                if (ENABLE_BLOCK) {
                    return Promise.reject(evt);
                }
                else {
                    return _fetch(input, init);
                }
            }
        }
    };
    self.fetch = patchedFetch;
};
patch$1();

// https://html.spec.whatwg.org/multipage/web-sockets.html
var patch$2 = function () {
    // @ts-ignore
    if (!self.WebSocket)
        return;
    // @ts-ignore
    var WS = self.WebSocket;
    var patchedWS = function (url) {
        // init key
        var u = parse(url);
        var key = "WS|" + u.protocol + "//" + u.host + u.pathname;
        // update state
        var state = StateMgr.get(key);
        if (state.shouldIgnore()) {
            return new WS(url);
        }
        else {
            // allow/block request
            state.go('add');
            if (!state.shouldBlock()) {
                report$1.allow(key);
                var endHandler = function () { return state.go('substract'); };
                var ws = new WS(url);
                ws.addEventListener('close', endHandler);
                ws.addEventListener('error', endHandler);
                return ws;
            }
            else {
                report$1.block(key, url);
                state.go('substract');
                if (ENABLE_BLOCK) {
                    throw evt;
                }
                else {
                    return new WS(url);
                }
            }
        }
    };
    for (var k in WS) {
        // @ts-ignore
        patchedWS[k] = WS[k];
    }
    // @ts-ignore
    self.WebSocket = patchedWS;
};
patch$2();

// https://html.spec.whatwg.org/multipage/server-sent-events.html
var patch$3 = function () {
    // @ts-ignore
    if (!self.EventSource)
        return;
    // @ts-ignore
    var ES = self.EventSource;
    var patchedES = function (url, configuration) {
        // init key
        var u = parse(url);
        var key = "ES|" + u.protocol + "//" + u.host + u.pathname;
        // update state
        var state = StateMgr.get(key);
        if (state.shouldIgnore()) {
            return new ES(url, configuration);
        }
        else {
            // allow/block request
            state.go('add');
            if (!state.shouldBlock()) {
                report$1.allow(key);
                var endHandler_1 = function () { return state.go('substract'); };
                var es_1 = new ES(url, configuration);
                es_1.addEventListener('error', endHandler_1);
                var _close_1 = es_1.close;
                es_1.close = function () {
                    endHandler_1();
                    _close_1.call(es_1);
                };
                return es_1;
            }
            else {
                report$1.block(key, url);
                state.go('substract');
                if (ENABLE_BLOCK) {
                    var esc_1 = new ES(url, configuration);
                    esc_1.close();
                    setTimeout(function () { return esc_1.dispatchEvent(evt); });
                    return esc_1;
                }
                else {
                    return new ES(url, configuration);
                }
            }
        }
    };
    for (var k in ES) {
        // @ts-ignore
        patchedES[k] = ES[k];
    }
    // @ts-ignore
    self.EventSource = patchedES;
};
patch$3();

}());



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/paprika/_build/index.js
// module id = 1027
// module chunks = 1